class FormValidator {
    constructor(form) {
        this.form = form;
        this.initialize();
    }
  
    initialize() {
        const elements = this.form.querySelectorAll('[data-validation]');
        elements.forEach((element) => {
            const validationRules = element.getAttribute('data-validation').split('|');
            
            // Only add event listeners if "required" is one of the validation rules
            if (validationRules.includes('required')) {
                if (element.type === 'radio') { // Check for radio buttons
                    element.addEventListener('change', () => { 
                        this.validateField(element);
                    });
                } else if (element.type === 'checkbox') { // Check for checkboxes
                    element.addEventListener('change', () => {
                        this.validateField(element);
                    });
                } else {
                    element.addEventListener('input', () => { 
                        this.validateField(element);
                    });
                }
            }
        });
    }
  
    validateFieldset(fieldset) {
        const elements = fieldset.querySelectorAll('[data-validation]');
        let hasErrors = false;
  
        elements.forEach((element) => {
            this.validateField(element);
  
            if (element.classList.contains('error')) {
                hasErrors = true;
            }
        });
  
        return !hasErrors;
    }
  
    isVisible(element) {
        const isVisible = element.offsetWidth > 0 || element.offsetHeight > 0;
        console.log(`Element "${element.tagName}" visibility: ${isVisible}`);
        return isVisible;
    }
  
    validateField(element) {
        const validationRules = element.getAttribute('data-validation').split('|');
        const value = element.value;
        let hasError = false;
        let errorMessage = '';
    
        if (element.type === 'radio') {
            const groupName = element.name;
            if (validationRules.includes('required')) {
                const checkedRadio = this.form.querySelector(`input[name="${groupName}"]:checked`);
                if (!checkedRadio) {
                    hasError = true;
                    errorMessage = 'Bitte wähle eine Option';  // Please select an option
                }
            }
        } else if (element.type === 'checkbox') { 
            const groupName = element.name;
            const checkedCheckboxes = this.form.querySelectorAll(`input[name="${groupName}"]:checked`);
            if (checkedCheckboxes.length === 0 && validationRules.includes('required')) { 
                hasError = true;
                errorMessage = 'Bitte Option auswählen';  // Please select an option
            }
        }
    
        validationRules.forEach((rule) => {
            const [ruleName, ruleValue] = rule.split(':');
            switch (ruleName) {
                case 'required':
                    if (!value.trim()) {
                        hasError = true;
                        errorMessage = 'This field is required'; // This field is required
                    }
                    break;
    
                case 'minLength':
                    if (value.length < parseInt(ruleValue)) {
                        hasError = true;
                        errorMessage = `Minimum length is ${ruleValue}`;
                    }
                    break;
    
                case 'maxLength':
                    if (value.length > parseInt(ruleValue)) {
                        hasError = true;
                        errorMessage = `Maximum length is ${ruleValue}`;
                    }
                    break;
    
                case 'min':  // Validate minimum value for numbers
                    if (parseFloat(value) < parseFloat(ruleValue)) {
                        hasError = true;
                        errorMessage = `Der Wert muss größer als ${ruleValue} sein`;  // The value must be greater than min
                    }
                    break;
    
                case 'max':  // Validate maximum value for numbers
                    if (parseFloat(value) > parseFloat(ruleValue)) {
                        hasError = true;
                        errorMessage = `Der Wert muss kleiner als ${ruleValue} sein`;  // The value must be less than max
                    }
                    break;
    
                case 'passwordLength':
                    const minLength = ruleValue || 8; // Default password length is 8 if not specified
                    if (value.length < parseInt(minLength)) {
                        hasError = true;
                        errorMessage = `Das Passwort muss mindestens ${minLength} Zeichen lang sein.`;
                    }
                    break;
    
                case 'email':
                    if (!this.isValidEmail(value)) {
                        hasError = true;
                        errorMessage = 'Invalid Email format'; // Invalid email format
                    }
                    break;
    
                case 'match':
                    const targetField = this.form.querySelector(`[name="${ruleValue}"]`);
                    if (value && value !== targetField.value) {
                        hasError = true;
                        errorMessage = 'Passwörter stimmen nicht überein'; // Passwords do not match
                    } else if (value && value === targetField.value) {
                        let errorSpan = targetField.parentElement.querySelector('.error__msg');
                        if (errorSpan) {
                            errorSpan.remove();
                        }
                    }
                    break;
                // Add more validation rules as needed
            }
        });
    
        let parentField = element.closest('.da__form-field');
    
        if (hasError) {
            // Ensure the error message span is not interfering with the field
            element.classList.add('error'); 
            let errorMsgSpan = parentField.querySelector('.error__msg');
            if (!errorMsgSpan) {
                errorMsgSpan = document.createElement('span');
                errorMsgSpan.classList.add('error__msg');
                parentField.appendChild(errorMsgSpan);
            }
            errorMsgSpan.textContent = errorMessage;
        } else {
            element.classList.remove('error');
            let errorMsgSpan = parentField.querySelector('.error__msg');
            if (errorMsgSpan) {
                errorMsgSpan.textContent = ''; // Clear the error message instead of removing the span
            }
        }
    }
    
  
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
  
    validate() {
        const elements = this.form.querySelectorAll('[data-validation]');
        let hasErrors = false;
  
        elements.forEach((element) => {
            if (element.getAttribute('data-validation').includes('required')) {
                this.validateField(element);
                if (element.classList.contains('error')) {
                    hasErrors = true;
                }
            }
        });
  
        return !hasErrors;
    }
  
    getErrors() {
        const elements = this.form.querySelectorAll('[data-validation]');
        const errors = {};
  
        elements.forEach((element) => {
            const errorSpan = element.parentElement.querySelector('.error');
            if (errorSpan && errorSpan.classList.contains('show')) {
                errors[element.name] = errorSpan.textContent;
            }
        });
        return errors;
    }
  }
  
  export default FormValidator;
  